import { Directive, ElementRef, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

const base = 'prose max-w-none rounded-full transition-all ease-out duration-300';
const sizeLg = 'prose-text-md px-5 py-3';
const sizeSm = 'prose-text-sm px-3 py-1.5';
const colorPrimary =
  'bg-primary-600 font-semibold text-white hover:bg-primary-800 active:bg-primary-900 disabled:bg-neutral-500';
const colorSecondary =
  'border border-neutral-900 bg-white font-semibold text-neutral-900 hover:bg-neutral-100 active:bg-neutral-300 disabled:border-neutral-500 disabled:bg-neutral-200 disabled:text-neutral-500';
const colorTertiary =
  '!px-0 !py-0 font-medium text-neutral-900 hover:underline active:no-underline disabled:text-neutral-500';

type Color = 'primary' | 'secondary' | 'tertiary';
type Size = 'lg' | 'sm';

const buildTwClasses = (className: string, color: Color = 'primary', size: Size = 'lg'): string =>
  `${className} ${base} ${size === 'lg' ? sizeLg : sizeSm} ${
    color === 'primary' ? colorPrimary : color === 'secondary' ? colorSecondary : colorTertiary
  }`;

@Directive({
  selector: '[app-button]',
  exportAs: 'appButton'
})
export class ButtonDirective implements OnChanges {
  @HostBinding('class')
  private twClasses = buildTwClasses(this.element.nativeElement.className);

  @Input() color: Color = 'primary';
  @Input() size: Size = 'lg';

  constructor(private element: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.twClasses = buildTwClasses(this.element.nativeElement.className, this.color, this.size);
  }
}
